import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  AccessTime,
  CheckCircle,
  Done,
  Cancel
} from '@mui/icons-material';

interface VisitStatusBadgeProps {
  status: string;
  size?: 'small' | 'medium';
}

const VisitStatusBadge: React.FC<VisitStatusBadgeProps> = ({ status, size = 'small' }) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'pending_confirmation':
        return {
          label: 'In asteptare confirmare',
          color: '#FFC107',
          bgcolor: '#FFF6D5',
          textColor: '#8A6D00',
          icon: <AccessTime sx={{ fontSize: 16 }} />,
          tooltip: 'Astepta confirmarea clinicii'
        };
      case 'confirmed':
        return {
          label: 'Confirmata',
          color: '#22C55E',
          bgcolor: '#EAF9F0',
          textColor: '#136F2D',
          icon: <CheckCircle sx={{ fontSize: 16 }} />,
          tooltip: 'Programarea a fost confirmata de clinica'
        };
      case 'scheduled':
        return {
          label: 'Programata',
          color: '#0D6EFD',
          bgcolor: '#E9F2FF',
          textColor: '#0D3B8F',
          icon: <CheckCircle sx={{ fontSize: 16 }} />,
          tooltip: 'Programare planificata'
        };
      case 'completed':
        return {
          label: 'Finalizata',
          color: '#0D6EFD',
          bgcolor: '#E9F2FF',
          textColor: '#0D3B8F',
          icon: <Done sx={{ fontSize: 16 }} />,
          tooltip: 'Vizita a fost finalizata'
        };
      case 'cancelled':
        return {
          label: 'Anulata',
          color: '#EF4444',
          bgcolor: '#FDECEC',
          textColor: '#7F1D1D',
          icon: <Cancel sx={{ fontSize: 16 }} />,
          tooltip: 'Programarea a fost anulata'
        };
      default:
        return {
          label: status,
          color: '#9CA3AF',
          bgcolor: '#F3F4F6',
          textColor: '#374151',
          icon: null,
          tooltip: status
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Tooltip title={config.tooltip} arrow>
      <Chip
        icon={config.icon || undefined}
        label={config.label}
        size={size}
        sx={{
          bgcolor: config.bgcolor,
          color: config.textColor,
          fontWeight: 600,
          fontSize: size === 'small' ? '0.75rem' : '0.875rem',
          height: size === 'small' ? 24 : 28,
          border: `1px solid ${config.color}20`,
          '& .MuiChip-icon': {
            color: config.textColor
          }
        }}
      />
    </Tooltip>
  );
};

export default VisitStatusBadge;

